import React from 'react';
import './Bio.css';

const Bio = () => {
  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="section-label">ABOUT · AVI DESAI</div>
        <h2 className="about-heading">About</h2>
        <div className="about-content">
          <p className="about-text">
            I'm a Computer Science student at UC Berkeley working across software, AI, and consulting. I turn ambiguous ideas into shipped products—whether that's building ML models, designing software architecture, or leading technical teams for startups.
          </p>
          <div className="about-info-strip">
            <div className="info-item">
              <div className="info-label">Current</div>
              <div className="info-value">Consulting on AI for orgs</div>
            </div>
            <div className="info-item">
              <div className="info-label">Interests</div>
              <div className="info-value">ML, SaaS, agentic systems</div>
            </div>
            <div className="info-item">
              <div className="info-label">Location</div>
              <div className="info-value">Berkeley, CA</div>
            </div>
          </div>
          <div className="about-divider"></div>
        </div>
      </div>
    </section>
  );
};

export default Bio;
